const { $paths } = require("@/constants");
import { appConfig } from "@/config";

// Application layouts
const { layouts } = appConfig;

/** Routes meta  */
const meta = { layout: layouts.app, requiresAuth: true };

/**
 * Seed routes
 */
const seedRoutes = [
  {
    path: $paths.seeds,
    name: "manage-seeds",
    meta,
    component: () => import("@/views/ManageSeeds.vue"),
  },
];

export default seedRoutes;
